<template>
    <div>
        <h4>Limites de Sensores</h4>
        <hr />
        <b-button variant="secondary" class="mb-3" @click="addLimit"
            ><i class="fas fa-plus-circle mr-2" />Criar limite</b-button
        >
        <sensor-limit-table
            :source="source"
            :sensors="sensors"
            :limits="limits"
            :reading-kinds="readingKinds"
            @update-limit="updateLimit"
            @delete-limit="deleteLimit"
        />
        <sensor-limit-create-modal
            ref="createModal"
            :source="source"
            :sensors="sensors"
            :reading-kinds="readingKinds"
            @create-limit="createLimit"
        />
    </div>
</template>

<script>
import settingsApi from "@/modules/settings/api";
import commonApi from "@/modules/common/api";
import format from "@/utils/format";
import { AlertLevels as AL, LimitConditions } from "@/modules/common/settings";
import SensorLimitTable from "./components/SensorLimitTable";
import SensorLimitCreateModal from "./components/SensorLimitCreateModal";

const AlertLevels = {
    ...AL,
    [AL.INFO]: "Informação",
    [AL.WARNING]: "Aviso",
    [AL.CRITICAL]: "Crítico"
};

const optionsConditions = [
    {
        value: LimitConditions.GREATER_THAN,
        text: LimitConditions[LimitConditions.GREATER_THAN]
    },
    {
        value: LimitConditions.GREATER_THAN_OR_EQUAL,
        text: LimitConditions[LimitConditions.GREATER_THAN_OR_EQUAL]
    },
    {
        value: LimitConditions.LESS_THAN,
        text: LimitConditions[LimitConditions.LESS_THAN]
    },
    {
        value: LimitConditions.LESS_THAN_OR_EQUAL,
        text: LimitConditions[LimitConditions.LESS_THAN_OR_EQUAL]
    }
];

const optionsAlerts = [
    {
        value: AlertLevels.INFO,
        text: AlertLevels[AlertLevels.INFO]
    },
    {
        value: AlertLevels.WARNING,
        text: AlertLevels[AlertLevels.WARNING]
    },
    {
        value: AlertLevels.CRITICAL,
        text: AlertLevels[AlertLevels.CRITICAL]
    }
];

export default {
    name: "LimitesManagement",
    components: {
        SensorLimitTable,
        SensorLimitCreateModal
    },
    props: {
        source: {
            type: Number,
            required: true
        },
        readingKinds: {
            type: Object,
            required: true
        }
    },
    data() {
        return {
            limits: [],
            sensors: []
        };
    },
    provide() {
        return {
            getOptionsSensors: this.getOptionsSensors,
            optionsConditions,
            LimitConditions,
            format,
            getOptionsKinds: this.getOptionsKinds,
            getAlertVariant: this.getAlertVariant,
            AlertLevels,
            optionsAlerts
        };
    },
    created() {
        this.getLimits();
        this.getSensors();
    },
    methods: {
        async getLimits() {
            this.limits = (
                await settingsApi.sensors.getlimits(this.source)
            ).data;
        },
        async getSensors() {
            this.sensors = (await commonApi.getSensors(this.source)).data;
        },
        getOptionsSensors() {
            return this.sensors.map(sensor => ({
                value: sensor.id,
                text: sensor.name
            }));
        },
        getOptionsKinds(kind) {
            const readingKinds = this.readingKinds[kind];
            return Object.keys(readingKinds).map(readingKind => ({
                value: readingKind,
                text: readingKinds[readingKind]
            }));
        },
        getAlertVariant(alertLevel) {
            if (alertLevel === AlertLevels.WARNING) {
                return "warning";
            } else if (alertLevel === AlertLevels.CRITICAL) {
                return "danger";
            }
            return "info";
        },
        updateLimit({ index, limit }) {
            this.$set(this.limits, index, limit);
        },
        deleteLimit({ index }) {
            this.$delete(this.limits, index);
        },
        createLimit(limit) {
            this.limits.unshift(limit);
        },
        addLimit() {
            this.$refs.createModal.show();
        }
    }
};
</script>
